<template>
  <div class="foldopen">
    <div class="wrapper">
      <div class="openbox-container" style="margin-top: 0px" ref="openBox">
        <div class="content" style="height: calc(100vh - 101px); width: 350px">
          <div class="btn-class">
            <div class="model-btn" @click="changModelMap">地图模式</div>
            <div class="model-btn" @click="changModelVideo">视频模式</div>
          </div>
          <!-- 设备单位树 -->

          <el-tree
            class="treeBox"
            :data="ArchInfoShow == true ? this.ArchInfo : this.onlineArchInfo"
            :props="defaultTreesProps"
            default-expand-all
            :expand-on-click-node="false"
            :highlight-current="true"
            @node-click="handleNodeClick"
            ref="navTree"
          >
            <!-- el-tree多选框 -->
            <!-- show-checkbox -->

            <!-- :render-content="renderContent"  -->
            <span slot-scope="{ node, data }">
              <div class="bigTree">
                <div class="leftTree">
                  <div>
                    <!-- 单位图标 -->
                    <img
                      v-show="data.type == 1"
                      style="width: 24px; height: 24px; margin-right: 2px"
                      src="../../../assets/img/tree/dw.svg"
                    />

                    <!-- 人员图标 -->
                    <img
                      v-show="data.type == 2"
                      style="width: 24px; height: 24px; margin-right: 2px"
                      src="../../../assets/img/tree/ry.svg"
                    />
                    <!-- 执法仪不在线图标 -->
                    <img
                      v-show="data.type == 3 && data.status.online == false"
                      style="width: 24px; height: 24px"
                      :src="
                        data.devideType == 1
                          ? require('../../../assets/img/tree/zfy.svg')
                          : data.devideType == 2
                          ? require('../../../assets/img/tree/bkq.svg')
                          : data.devideType == 3
                          ? require('../../../assets/img/tree/aqm.svg')
                          : data.devideType == 4
                          ? require('../../../assets/img/tree/wrj.svg')
                          : data.devideType == 5
                          ? require('../../../assets/img/tree/jksxj.svg')
                          : require('../../../assets/img/tree/zngb.svg')
                      "
                    />
                    <!-- 执法仪在线图标 -->
                    <img
                      v-show="data.type == 3 && data.status.online == true"
                      style="width: 24px; height: 24px"
                      :src="
                        data.devideType == 1
                          ? require('../../../assets/img/tree/zfy_online.svg')
                          : data.devideType == 2
                          ? require('../../../assets/img/tree/bkq_online.svg')
                          : data.devideType == 3
                          ? require('../../../assets/img/tree/aqm_online.svg')
                          : data.devideType == 4
                          ? require('../../../assets/img/tree/wrj_online.svg')
                          : data.devideType == 5
                          ? require('../../../assets/img/tree/jksxj_online.svg')
                          : require('../../../assets/img/tree/zngb_online.svg')
                      "
                    />
                  </div>

                  <!-- 设备名称 -->
                  <el-tooltip
                    v-show="data.type == 3"
                    class="item"
                    effect="dark"
                    :content="node.label"
                    placement="top"
                  >
                    <div ref="nodeLabel">
                      <div v-if="node.label.length > 8">
                        {{
                          node.label.replace(
                            /(\d{3})\d*([0-9a-zA-Z]{3})/,
                            "$1***$2"
                          )
                        }}
                      </div>
                      <div v-else>
                        {{ node.label }}
                      </div>
                    </div>
                  </el-tooltip>
                  <div
                    style="
                      color: #48dacf;
                      line-height: 26px;
                      height: 26px;
                      font-size: 0.8rem;
                    "
                    v-show="data.type == 3 && data.status.online == true"
                  >
                    {{
                      `[${
                        data.type == 3 && data.status.battery != null
                          ? "电量:" + data.status.battery + "%;"
                          : ""
                      }${
                        data.type == 3 && data.status.video == true
                          ? "录像中;"
                          : ""
                      }${
                        data.type == 3 && data.status.audio == true
                          ? "录音中;"
                          : ""
                      }
                      ${
                        data.type == 3 && data.status.push == true
                          ? "呼叫中;"
                          : ""
                      }]`
                    }}
                  </div>
                  <!--  -->
                  <!-- 单位和人员名称 -->
                  <div
                    ref="nodeLabel"
                    v-show="data.type == 1 || data.type == 2"
                  >
                    {{ node.label }}
                  </div>
                </div>

                <!-- 右边实时视频和远程控制 -->
                <div class="rightTree">
                  <!-- 只显示是设备层级，在线设备 -->
                  <div v-if="data.type == 3 && data.status.online == true">
                    <!-- 当时设备在线时，devideType != 6 时显示（只能广播不显示） -->
                    <img
                      style="width: 24px; height: 24px"
                      title="实时视频"
                      src="../../../assets/img/tree/sssp.svg"
                      @click="playVideo(data)"
                      class="imgHover"
                      v-if="data.devideType != 6"
                    />
                    <!-- 远程控制按钮，只有是设备协议为私有协议，设备在线，type=3并且devideType != 6时才显示  （设备在线，且为设备层，设备不为智能广播） -->
                    <img
                      v-if="
                        data.type == 3 &&
                          data.status.online == true &&
                          data.devProtocol == 1 &&
                          data.devideType != 6
                      "
                      style="width: 24px; height: 24px"
                      title="远程控制"
                      src="../../../assets/img/tree/kz.svg"
                      @click="controlDialogVisible = true"
                      class="imgHover"
                    />
                    <img
                      v-if="
                        data.type == 3 &&
                          data.status.online == true &&
                          data.devProtocol == 1 &&
                          data.devideType == 6
                      "
                      style="width: 24px; height: 24px"
                      title="消息推送"
                      src="../../../assets/img/tree/kz.svg"
                      @click="MessagePushDialogVisible = true"
                      class="imgHover"
                    />
                  </div>
                </div>
              </div>
            </span>
            <!-- :render-content="renderContent" -->
          </el-tree>

          <!-- 切换设备全部列表和在线设备列表 -->
          <div class="listStatusBtn">
            <el-button
              type="primary"
              size="mini"
              style="width: 50%; margin-left: 10px"
              :disabled="this.ArchInfoShow"
              @click="allList"
            >
              全部设备
            </el-button>
            <el-button
              type="primary"
              size="mini"
              style="width: 50%; margin-right: 10px"
              :disabled="!this.ArchInfoShow"
              @click="onlineList"
              plain
            >
              在线设备
            </el-button>
          </div>
          <!-- <el-tree :data="ArchInfo" node-key="depId" show-checkbox accordion @check-change="handleCheckChange"></el-tree> -->
        </div>
      </div>
      <div @click="clickOpenHidden" v-show="this.changModel == false">
        <i
          style="color: #48dacf; font-size: 1.3rem"
          :class="isOpen ? 'el-icon-caret-left' : 'el-icon-caret-right'"
        ></i>
      </div>
    </div>

    <!-- 中间地图或视频窗口 -->
    <div class="center-box">
      <!-- 地图模式 -->
      <div class="bm-view" v-show="changModel">
        <div id="container"></div>
        <div
          style="position: absolute; right: 10px; bottom: 100px; z-index: 9999"
        >
          <button @click="BmapNormalMap()">普通</button><br />
          <button @click="BmapSatelliteMap()">卫星</button>
        </div>
      </div>
      <!-- 视频模式 -->
      <div class="video1Model" v-show="!changModel">
        <div class="fp-box">
          <button class="fp-btn" @click="pfOne()">1分屏</button>
          <button class="fp-btn" @click="pfFour()">4分屏</button>
          <button class="fp-btn" @click="pfEight()">8分屏</button>
          <button class="fp-btn" @click="pfSixteen()">16分屏</button>
          <button class="fp-btn" @click="pfThirty()">30分屏</button>
          <button class="fp-btn" @click="onStop()">全部关闭</button>
          <!-- <button class="fp-btn" @click="onPlay()">播放测试</button> -->
        </div>
        <div class="box">
          <div
            v-for="(item, index) in easyPlayer"
            :key="index"
            :style="
              'width:' +
                playerWidth +
                ';' +
                'height:' +
                playerHeight +
                ';' +
                'margin:1.5px;'
            "
            @click="onActive(index)"
          >
            <!-- <div class="num">{{ item.num }}</div> -->
            <div
              class="closes"
              v-show="item.url && active == index"
              @click="onCloes(index)"
            >
              关闭
            </div>
            <!-- :class="active == index ? 'boder-active' : 'boder'" -->
            <div id="playerContainer">
              <easy-player
                live
                fluent
                alt="无信号接入"
                :class="active == index ? 'boder-active' : 'boder'"
                :muted="item.muted"
                :autoplay="item.autoplay"
                :video-url="item.url"
                :isH265="true"
                :reconnection="true"
                ref="easyPlayer"
                @play="onPlay"
              >
                <!-- 关闭音频输出 -->
                <!-- :has-audio="false" -->
              </easy-player>
              <div
                id="ytButton"
                width="80px"
                height="80px"
                v-show="item.url"
                v-if="active == index && item.ytBoxShow == true"
              >
                <div>
                  <i
                    @mousedown="cameraCmd('up')"
                    @mouseup="cameraCmd('stop')"
                    class="el-icon-caret-top up cameraCmd"
                  ></i>
                </div>
                <div>
                  <i
                    @mousedown="cameraCmd('right')"
                    @mouseup="cameraCmd('stop')"
                    class="el-icon-caret-top rg cameraCmd"
                  ></i>
                  <i
                    @mousedown="cameraCmd('down')"
                    @mouseup="cameraCmd('stop')"
                    class="el-icon-caret-top dw cameraCmd"
                  ></i>
                  <i
                    @mousedown="cameraCmd('left')"
                    @mouseup="cameraCmd('stop')"
                    class="el-icon-caret-top lt cameraCmd"
                  ></i>
                  <img
                    @mousedown="cameraCmd('zoomIn')"
                    @mouseup="cameraCmd('stop')"
                    class="zoomIn"
                    width="40px"
                    src="../../../assets/img/liveVideo/zoomIn.png"
                    alt=""
                  />
                  <img
                    @mousedown="cameraCmd('zoomOut')"
                    @mouseup="cameraCmd('stop')"
                    class="zoomOut"
                    width="40px"
                    src="../../../assets/img/liveVideo/zoomOut.png"
                    alt=""
                  />
                </div>
                <!-- <div ><i class="el-icon-caret-top slice" style="font-size: 3rem;color: rgba(240, 248, 255, 0.943);"></i></div>
                 <div ><i class="el-icon-caret-top slice" style="font-size: 3rem;color: rgba(240, 248, 255, 0.943);"></i></div> -->
              </div>

              <img
                v-show="item.url"
                v-if="item.IntercomState == true && active == index"
                id="intercomButton"
                width="40px"
                height="40px"
                @click="startCall(item.url, index)"
                ref="start"
                src="../../../assets/img/liveVideo/openMac.png"
                alt="开启对讲"
                title="开启对讲"
              />
              <img
                v-show="item.url"
                v-if="item.IntercomState == false && active == index"
                id="intercomButton"
                @click="stopCall(index)"
                ref="stop"
                width="40px"
                height="40px"
                src="../../../assets/img/liveVideo/closeMac1.png"
                alt="关闭对讲"
                title="关闭对讲"
              />
              <!-- <el-button
                v-show="item.url"
                v-if="IntercomState == true"
                id="intercomButton"
                @click="startCall"
                ref="start"
                >开始对讲</el-button
              >
              <el-button
                v-show="item.url"
                v-if="IntercomState == false"
                id="intercomButton"
                @click="stopCall"
                ref="stop"
                >结束对讲</el-button
              > -->
              <!-- <button v-show="item.url" id="intercomButton">
                {{ IntercomState == true ? "对讲" : "关闭" }}
              </button> -->
            </div>
          </div>
        </div>
      </div>
      <!-- <EasyPlayer :videoUrl="playerUrl" fluent autoplay live stretch>
          </EasyPlayer> -->
    </div>
    <el-dialog
      title="远程控制"
      :visible.sync="controlDialogVisible"
      width="550px"
    >
      <div class="controlBox">
        <div class="controlItem" @click="remoteCmd(2)">
          <img src="../../../assets/img/liveVideo/kslx.svg" alt="" />
          <div>开始录像</div>
        </div>
        <div class="controlItem" @click="remoteCmd(3)">
          <img src="../../../assets/img/liveVideo/tzlx.svg" alt="" />
          <div>结束录像</div>
        </div>
        <div class="controlItem" @click="remoteCmd(4)">
          <img src="../../../assets/img/liveVideo/ksly.svg" alt="" />
          <div>开始录音</div>
        </div>
        <div class="controlItem" @click="remoteCmd(5)">
          <img src="../../../assets/img/liveVideo/tzly.svg" alt="" />
          <div>结束录音</div>
        </div>
        <div class="controlItem" @click="remoteCmd(1)">
          <img src="../../../assets/img/liveVideo/pz.svg" alt="" />
          <div>拍照</div>
        </div>
        <div class="controlItem" @click="remoteCmd(6)">
          <img src="../../../assets/img/liveVideo/cq.svg" alt="" />
          <div>重启</div>
        </div>
        <div class="controlItem" @click="remoteCmd(7)">
          <img src="../../../assets/img/liveVideo/gj.svg" alt="" />
          <div>关机</div>
        </div>
        <div class="controlItem" @click="remoteCmd(8)">
          <img src="../../../assets/img/liveVideo/qcsj.svg" alt="" />
          <div>清除媒体数据</div>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      title="消息推送"
      :visible.sync="MessagePushDialogVisible"
      width="550px"
    >
      <el-dialog
        width="30%"
        title="文字推送"
        :visible.sync="innerPushTxtVisible"
        append-to-body
        @close="clearinnerPushTxtVisiblee()"
      >
        <el-input
          type="textarea"
          :rows="4"
          placeholder="请输入内容"
          v-model="controlInfo.txt"
        >
        </el-input>
        <span slot="footer" class="dialog-footer">
          <el-button @click="innerPushTxtVisible = false">取 消</el-button>
          <el-button type="primary" @click="remoteCmd(21)">确 定</el-button>
        </span>
      </el-dialog>
      <div class="controlBox">
        <div class="controlItem" @click="innerPushTxtVisible = true">
          <img src="../../../assets/img/liveVideo/fswb.svg" alt="" />
          <div>推送文字</div>
        </div>
        <div class="controlItem" @click="remoteCmd(6)">
          <img src="../../../assets/img/liveVideo/cq.svg" alt="" />
          <div>重启</div>
        </div>
        <div class="controlItem" @click="remoteCmd(7)">
          <img src="../../../assets/img/liveVideo/gj.svg" alt="" />
          <div>关机</div>
        </div>
      </div>
    </el-dialog>

    <el-dialog
      :title="'sos呼叫:' + sosDeviceNumber"
      :visible.sync="sendSosDialog"
      width="700px"
      height="500px"
      :close-on-click-modal="false"
      v-dialog-move
      @close="clearPlayerSosDialogVisible()"
    >
      <div style="width: 660px; height: 500px" id="playerContainer1">
        <easy-player
          live
          fluent
          alt="无信号接入"
          muted
          autoplay
          :video-url="this.playerSosUrl"
          isH265
          :reconnection="true"
        ></easy-player>
        <img
          v-show="this.playerSosUrl"
          v-if="macSosShow == false"
          @click="startSosCall()"
          id="intercomButton1"
          width="40px"
          height="40px"
          ref="start"
          src="../../../assets/img/liveVideo/openMac.png"
          alt="开启对讲"
          title="开启对讲"
        />
        <img
          v-show="this.playerSosUrl"
          v-if="macSosShow == true"
          @click="stopSosCall()"
          id="intercomButton1"
          ref="stop"
          width="40px"
          height="40px"
          src="../../../assets/img/liveVideo/closeMac1.png"
          alt="关闭对讲"
          title="关闭对讲"
        />
      </div>
    </el-dialog>
    <!-- sos报警声 -->
    <audio
      muted="muted"
      ref="audio"
      src="../../../assets/img/liveVideo/sos.mp3"
    >
      <!-- <source  /> -->
    </audio>
  </div>
</template>

<script>
// 引入百度地图样式
import custom_map_config from "../../../assets/css/custom_map_config4.json";
// 播放器
import EasyPlayer from "@easydarwin/easyplayer";
// import { EventBus } from "../../../utils/eventBus";
export default {
  data() {
    return {
      ws: null,
      mediaStack: null,
      audioCtx: null,
      scriptNode: null,
      source: null,
      play: true,
      spacePressed: false, // 添加一个是否开启了对讲标记
      call: {
        speakType: "device", //group标识群组  device标识单个设备
        id: "" //group的时候标识群组号device的时候标识设备编号  测试：832136180001550
      },

      // 远程控制对话框状态
      controlDialogVisible: false,
      //消息推送对话框状态
      MessagePushDialogVisible: false,
      //文字消息推送对话框状态
      innerPushTxtVisible: false,
      textarea: "",
      // 远程控制查询参数
      controlInfo: {
        // 设备编号
        deviceNumber: "",
        // 控制指令：1:拍照 2:开始录像 3:结束录像 4:开始录音 5:结束录音 6:重启 7:关机 8.清除执法仪媒体数据  21：给智能广播发送文本
        cmdType: "",
        // 布控球云台控制： up down left right leftUp rightUp rightDown leftDown zoomIn zoomOut stop
        cmd: "",
        // 智能广播文本内容
        txt: ""
      },
      // 实时视频设备编号
      deviceNumber: "",
      isOpen: true, // 是否展开下方折叠内容
      openWidth: 0, // 折叠面板内容初始宽度
      // 当前时间
      nowTime: "",
      // 模式切换
      changModel: true,
      // 默认地图中心点经度
      mapCenterLng: "113.75842",
      // 默认地图中心点纬度
      mapCenterLat: "23.027308",
      // 默认地图缩放级别
      mapZoom: 12,
      // 播放器
      easyPlayer: [],
      // 当前选中窗口
      active: 0,
      //拉流地址
      path: "",
      //播放窗口宽
      playerWidth: "50%",
      //播放窗口高
      playerHeight: "50%",
      playerUrl: "",
      // 云台是否显示
      ytBox: false,
      // "https://sf1-cdn-tos.huoshanstatic.com/obj/media-fe/xgplayer_doc_video/mp4/xgplayer-demo-360p.mp4",
      // "http://183.11.232.241:10010/live/1_93_1.flv?port=23101&user=B38AAADF-3640-4110",
      // 全部单位人员设备树
      ArchInfo: [],
      depId: "", // 现在对应单位ID
      // 在线单位人员设备树
      onlineArchInfo: [],
      // 切换全部数据和在线数据
      ArchInfoShow: true,
      // 单位信息
      areaList: [],
      // 用户列表
      userList: [],
      // 在线设备信息
      onlineDevice: [],

      // 组织架构信息显示树形控件
      defaultTreesProps: {
        children: "children",
        label: "name"
        // children: function (data, node) {
        //   console.log("data-1", data);
        //   console.log("node-1", node);
        // },
        // label: function (data, node) {
        //   if (node.data.depName) {
        //     return node.data.depName;
        //   } else if (node.data.persons) {
        //     return node.data.empName;
        //   }

        // },
      },
      count: 1,
      zd: true,
      // 设置定时器
      setInt: null,
      setTimeDepPersonDevTree: null, //定时获取单位人员设备树
      setIntMarker: null, //定时更新坐标标签，
      AlarmsList: [], //报警信息
      sendSosDialog: false, //sos报警视频弹框
      playerSosUrl: "", //sos视频报警
      setTimeGetAlarmsList: null, //定时获取报警信息
      macSosShow: false, //控制对讲按钮
      sosDeviceNumber: "" //sos请求的设备编号
    };
  },
  components: {
    EasyPlayer
  },
  beforeCreate() {},
  created() {
    // 获取报警信息定时器
    this.getNewAlarms();
    // const value = this.$route.params;
    // console.log('Received Value:', value);
  },
  //监听函数
  watch: {
    // ArchInfo: {
    //   handler(oldVal, newVal) {
    //     // this.ArchInfo = oldVal;
    //     console.log("旧值:" + JSON.stringify(oldVal));
    //     console.log("旧值:" + JSON.stringify(newVal));
    //     if (JSON.stringify(oldVal) !== JSON.stringify(newVal)) {
    //       this.ArchInfo =newVal
    //     }
    //     //   this.setTimeDepPersonDevTree = setTimeout(() => {
    //     //   this.getDepPersonDevTree();
    //     // }, 5000);
    //   },
    //   immediate: true,
    //   deep: true,
    // },
  },
  mounted() {
    // 接收单位ID
    // EventBus.$on("dId", data => {
    //   this.depId = data.depId;
    //   console.log("接收到的ID：", this.depId);
    // });
    // 获取组织架构信息
    this.getDepPersonDevTree();
    // 设置5秒发送请求一次获取组织架构信息
    this.setTimeDepPersonDevTree = setInterval(() => {
      this.getDepPersonDevTree();
    }, 5000);
    // 默认视频4路窗口
    this.pfFour();
    //实时设备预警
    this.open1();
    // 显示地图
    this.initMap();
    // 复制给window对象,实时视频
    window.playVideoMarker = this.playVideoMarker;
    // 复制给window对象,远程控制
    window.remoteCmdMarker = this.remoteCmdMarker;
  },
  beforeMount() {},
  updated() {},
  // 当data被修改时执行
  beforeUpdate() {},
  //离开页面清除获取服务器状态定时器
  beforeRouteLeave(to, from, next) {
    clearInterval(this.setInt);
    clearInterval(this.setIntMarker);
    // 在离开当前路由页面之前关闭WebSocket连接
    this.closeWebSocket();
    next();
  },
  beforeDestroy() {
    if (this.setTimeGetAlarmsList) {
      clearTimeout(this.setTimeGetAlarmsList); // 离开页面时清除报警定时器
    }
    if (this.setTimeDepPersonDevTree) {
      clearInterval(this.setTimeDepPersonDevTree);
    }
    // EventBus.$off("message"); // 清除监听器，避免内存泄漏
  },
  methods: {
    // 调用百度地图
    initMap() {
      setTimeout(() => {
        // 创建地图实例
        this.BMapGL = BMapGL; //把百度地图库引入到this
        this.map = new BMapGL.Map("container", {
          showVectorStreetLayer: true // 设置是否加载POI
          // showVectorLine: true, //设置是否加载路网数据，注意:路网数
        }); //container为dom元素id，创建Map实例
        //设置map显示类型
        //BMAP_SATELLITE_MAP 地图卫星模式
        //BMAP_NORMAL_MAP 普通模式
        this.map.setMapType(BMAP_NORMAL_MAP);
        // this.map.setMapType(BMAP_SATELLITE_MAP);
        //地图个性化样式
        this.map.setMapStyleV2({
          // styleId: "a0c43e8c7279db0a4a032712d0e4c32c", //官网地图api个性化获取
          // styleJson:[{}] //也可以json方式个性化
          styleJson: custom_map_config
          // styleJson: stylejson,
        });

        var zoomCtrl = new BMapGL.ZoomControl({
          // 控件的停靠位置
          anchor: BMAP_ANCHOR_TOP_RIGHT,
          // 控件基于停靠位置的偏移量（可选）
          offset: new BMapGL.Size(10, 5)
        }); // 添加缩放控件
        this.map.addControl(zoomCtrl);

        // 设置地图允许的最小级别。
        this.map.setMinZoom(5);

        var navi3DCtrl = new BMapGL.NavigationControl3D({
          anchor: BMAP_ANCHOR_BOTTOM_RIGHT,
          // 控件基于停靠位置的偏移量（可选）
          offset: new BMapGL.Size(5, 10)
        }); // 添加3D控件
        this.map.addControl(navi3DCtrl);
        //开启鼠标滚轮缩放
        this.map.enableScrollWheelZoom(true);

        setTimeout(() => {
          //  解决： Bug 百度地图centerAndZoom设置中心点后，中心点偏移
          //  原因：因为容器在隐藏和显示之间切换时，容器还没创建好，宽高为0，这时设置中心点就会是在左上角
          //  方法： 定时器setTimeout，延时设置中心点
          // 初始化地图,设置中心点坐标和地图级
          this.map.centerAndZoom(
            new BMapGL.Point(this.mapCenterLng, this.mapCenterLat),
            this.mapZoom
          );

          // 添加地图类型控件
          // this.map.addControl(
          //   new BMapGL.MapTypeControl({
          //     // 控件的停靠位置（可选，默认左上角）
          //     anchor: BMAP_ANCHOR_BOTTOM_RIGHT,
          //     // 控件基于停靠位置的偏移量（可选）
          //     offset: new BMapGL.Size(8, 70),
          //     mapTypes: [BMAP_NORMAL_MAP, BMAP_SATELLITE_MAP],
          //   })
          // );

          // 创建城市选择控件
          var cityControl = new BMapGL.CityListControl({
            // 控件的停靠位置（可选，默认左上角）
            anchor: BMAP_ANCHOR_TOP_RIGHT,
            // 控件基于停靠位置的偏移量（可选）
            offset: new BMapGL.Size(50, 5)
          });
          // 将控件添加到地图上
          this.map.addControl(cityControl);
        }, 1000);

        // 初始化地图，设置中心点坐标和地图级别
        // this.map.centerAndZoom(new BMapGL.Point(this.lng, this.lat), 5);

        //地图旋转角度
        // this.map.setHeading(10);

        //地图倾斜角度
        // this.map.setTilt(19);

        //修改地图中心点
        // this.map.setCenter(this.lng, this.lat);

        this.onlineDevice = [];
        // 清除标记物
        this.map.clearOverlays();
        // 获取在线设备信息
        this.levelOrderTraverse();

        // 创建执法仪图标
        var zfy_online = new BMapGL.Icon(
          "../static/images/map/zfy.png",
          new BMapGL.Size(50, 50)
        );
        // 创建安全帽图标
        var aqm_online = new BMapGL.Icon(
          "../static/images/map/aqm.png",
          new BMapGL.Size(50, 50)
        );
        // 创建布控球图标
        var aqm_online = new BMapGL.Icon(
          "../static/images/map/bkq.png",
          new BMapGL.Size(50, 50)
        );
        // 创建无人机图标
        var wrj_online = new BMapGL.Icon(
          "../static/images/map/wrj.png",
          new BMapGL.Size(50, 50)
        );
        // 创建摄像机
        var jksxj_online = new BMapGL.Icon(
          "../static/images/map/sxj.png",
          new BMapGL.Size(50, 50)
        );
        // 智能广播
        var zngb_online = new BMapGL.Icon(
          "../static/images/map/zngb.png",
          new BMapGL.Size(50, 50)
        );
        // 得到每台在线设备的信息
        for (let i = 0; i < this.onlineDevice.length; i++) {
          const element = this.onlineDevice[i];
          var lng = this.onlineDevice[i].status.lng;
          var lat = this.onlineDevice[i].status.lat;
          var name = this.onlineDevice[i].username;
          var devideType = this.onlineDevice[i].devideType;
          // console.log(lng, lat, name, devideType);

          // 创建Marker标注
          if (lng && lat) {
            if (lng[i] !== "0.0" && lat[i] !== "0.0") {
              // 转换后的才行设备经纬度
              var point = this.wgs84ToBd09(lng, lat);
              // console.log("point", point);
              var lng = point[0];
              var lat = point[1];
              let marker1 = new BMapGL.Marker(new BMapGL.Point(lng, lat), {
                icon:
                  devideType == 1
                    ? zfy_online
                    : devideType == 2
                    ? aqm_online
                    : devideType == 3
                    ? aqm_online
                    : devideType == 4
                    ? wrj_online
                    : devideType == 5
                    ? jksxj_online
                    : zngb_online,
                offset: new BMapGL.Size(0, -15)
              });
              this.map.addOverlay(marker1); //添加坐标

              //   // 添加点击事件，显示信息窗口
              marker1.addEventListener(
                "click",
                (function(marker, i, onlineDevice) {
                  // 这里我们添加了一个闭包来保存 `i` 的值
                  return function() {
                    // var opts = {
                    //   width: 230, // 信息窗口宽度
                    //   height: 100, // 信息窗口高度
                    //   title: retailInfo.na, // 信息窗口标题
                    //   message: retailInfo.na,
                    //   // 信息窗口消息
                    // };

                    if (onlineDevice.devideType != 6) {
                      var infoWindow = new BMapGL.InfoWindow(
                        "<div style='margin-left:60px;color:#fff;width: 85%;'>" +
                          "<div style='display: inline-block; width: 100%;' ><h3 style='color: #e6b726'>" +
                          onlineDevice.username +
                          "</h3><span style='position: absolute;right: 0;top: 10px;'><img src='../static/images/map/title-zfy.png' alt='实时视频' width='24px' height='24px'></span></div><hr>" +
                          "<div style='width: 90px;display:inline-block'>姓名：</div>" +
                          onlineDevice.username +
                          "</br><div style='width: 90px;display:inline-block'> 设备编号：</div>" +
                          onlineDevice.name +
                          "</br> <div style='width: 90px;display:inline-block'> 电量：</div>" +
                          onlineDevice.status.battery +
                          "%" +
                          "</span></br></p>" +
                          "<p style='font-size:12px;margin-bottom:40px;color:#48dacf;'  class='BmapCtl'><span style='margin-right: 10px'  onclick='playVideoMarker(" +
                          JSON.stringify(onlineDevice) +
                          ")'>实时视频</span><span style='margin-right: 10px' onclick='remoteCmdMarker(1," +
                          onlineDevice.name +
                          ")'>拍照</span><span  style='margin-right: 10px' onclick='remoteCmdMarker(6," +
                          onlineDevice.name +
                          ")'>重启</span><span  style='margin-right: 8px' onclick='remoteCmdMarker(7," +
                          onlineDevice.name +
                          ")'>关机</span></p>" +
                          "</div>"
                      ); // 创建信息窗口对象
                    } else {
                      var infoWindow = new BMapGL.InfoWindow(
                        "<div style='margin-left:60px;color:#fff;width: 85%;'>" +
                          "<div style='display: inline-block; width: 100%;' ><h3 style='color: #e6b726'>" +
                          onlineDevice.username +
                          "</h3><span style='position: absolute;right: 0;top: 10px;'><img src='../static/images/map/title-zfy.png' alt='实时视频' width='24px' height='24px'></span></div><hr>" +
                          "<div style='width: 90px;display:inline-block'>姓名：</div>" +
                          onlineDevice.username +
                          "</br><div style='width: 90px;display:inline-block'> 设备编号：</div>" +
                          onlineDevice.name +
                          "</br> <div style='width: 90px;display:inline-block'> 电量：</div>" +
                          onlineDevice.status.battery +
                          "%" +
                          "</span></br></p>" +
                          "<p style='font-size:12px;margin-bottom:40px;color:#48dacf;'  class='BmapCtl'><span  style='margin-right: 10px' onclick='remoteCmdMarker(6," +
                          onlineDevice.name +
                          ")'>重启</span><span  style='margin-right: 8px' onclick='remoteCmdMarker(7," +
                          onlineDevice.name +
                          ")'>关机</span></p>" +
                          "</div>"
                      ); // 创建信息窗口对象
                    }

                    this.map.openInfoWindow(infoWindow, marker.getPosition()); // 这里我们也需要将 marker 的位置传递给 openInfoWindow 方法，而不是零售点位置
                  };
                })(marker1, i, this.onlineDevice[i])
              );

              var opts = {
                position: new BMapGL.Point(lng, lat), // 指定文本标注所在的地理位置
                offset: new BMapGL.Size(18, -40) // 设置文本偏移量
              };
              // 创建文本标注对象
              var label = new BMapGL.Label(name, opts);
              // 自定义文本标注样式
              label.setStyle({
                color: "#076961",
                borderRadius: "5px",
                borderColor: "#ccc",
                fontWeight: 700,
                fontSize: "15px",
                height: "14px",
                padding: "2px",
                lineHeight: "14px",
                fontFamily: "微软雅黑"
              });

              this.map.addOverlay(label); //添加文本备注
            }
          }
        }
        this.setIntMarker = setInterval(() => {
          this.Marker();
        }, 30000);
      }, 400);
    },

    // 切换普通地图
    BmapNormalMap() {
      this.map.setMapType(BMAP_NORMAL_MAP);
    },
    // 切换卫星地图
    BmapSatelliteMap() {
      this.map.setMapType(BMAP_SATELLITE_MAP);
    },

    //更新图标
    Marker() {
      // 清除标记物
      this.map.clearOverlays();
      this.onlineDevice = [];
      // 获取在线设备信息
      this.levelOrderTraverse();
      // 创建执法仪图标
      var zfy_online = new BMapGL.Icon(
        "../static/images/map/zfy.png",
        new BMapGL.Size(50, 50)
      );
      // 创建安全帽图标
      var aqm_online = new BMapGL.Icon(
        "../static/images/map/aqm.png",
        new BMapGL.Size(50, 50)
      );
      // 创建布控球图标
      var aqm_online = new BMapGL.Icon(
        "../static/images/map/bkq.png",
        new BMapGL.Size(50, 50)
      );
      // 创建无人机图标
      var wrj_online = new BMapGL.Icon(
        "../static/images/map/wrj.png",
        new BMapGL.Size(50, 50)
      );

      // 创建摄像机
      var jksxj_online = new BMapGL.Icon(
        "../static/images/map/sxj.png",
        new BMapGL.Size(50, 50)
      );
      // 智能广播
      var zngb_online = new BMapGL.Icon(
        "../static/images/map/zngb.png",
        new BMapGL.Size(50, 50)
      );

      // 得到每台在线设备的信息
      for (let i = 0; i < this.onlineDevice.length; i++) {
        const element = this.onlineDevice[i];
        var lng = this.onlineDevice[i].status.lng;
        var lat = this.onlineDevice[i].status.lat;
        var name = this.onlineDevice[i].username;
        var devideType = this.onlineDevice[i].devideType;
        // console.log(lng, lat, name, devideType);
        // 创建Marker标注
        if (lng && lat) {
          if (lng[i] !== "0.0" && lat[i] !== "0.0") {
            // 转换后的才行设备经纬度
            var point = this.wgs84ToBd09(lng, lat);
            // console.log("point", point);
            var lng = point[0];
            var lat = point[1];

            let marker1 = new BMapGL.Marker(new BMapGL.Point(lng, lat), {
              icon:
                devideType == 1
                  ? zfy_online
                  : devideType == 2
                  ? aqm_online
                  : devideType == 3
                  ? aqm_online
                  : devideType == 4
                  ? wrj_online
                  : devideType == 5
                  ? jksxj_online
                  : zngb_online,
              offset: new BMapGL.Size(0, -15)
            });
            this.map.addOverlay(marker1); //添加坐标

            //   // 添加点击事件，显示信息窗口
            marker1.addEventListener(
              "click",
              (function(marker, i, onlineDevice) {
                // 这里我们添加了一个闭包来保存 `i` 的值
                return function() {
                  // var opts = {
                  //   width: 230, // 信息窗口宽度
                  //   height: 100, // 信息窗口高度
                  //   title: retailInfo.na, // 信息窗口标题
                  //   message: retailInfo.na,
                  //   // 信息窗口消息
                  // };
                  if (onlineDevice.devideType != 6) {
                    var infoWindow = new BMapGL.InfoWindow(
                      "<div style='margin-left:60px;color:#fff;width: 85%;'>" +
                        "<div style='display: inline-block; width: 100%;' ><h3 style='color: #e6b726'>" +
                        onlineDevice.username +
                        "</h3><span style='position: absolute;right: 0;top: 10px;'><img src='../static/images/map/title-zfy.png' alt='实时视频' width='24px' height='24px'></span></div><hr>" +
                        "<div style='width: 90px;display:inline-block'>姓名：</div>" +
                        onlineDevice.username +
                        "</br><div style='width: 90px;display:inline-block'> 设备编号：</div>" +
                        onlineDevice.name +
                        "</br> <div style='width: 90px;display:inline-block'> 电量：</div>" +
                        onlineDevice.status.battery +
                        "%" +
                        "</span></br></p>" +
                        "<p style='font-size:12px;margin-bottom:40px;color:#48dacf;'  class='BmapCtl'><span style='margin-right: 10px'  onclick='playVideoMarker(" +
                        JSON.stringify(onlineDevice) +
                        ")'>实时视频</span><span style='margin-right: 10px' onclick='remoteCmdMarker(1," +
                        onlineDevice.name +
                        ")'>拍照</span><span  style='margin-right: 10px' onclick='remoteCmdMarker(6," +
                        onlineDevice.name +
                        ")'>重启</span><span  style='margin-right: 8px' onclick='remoteCmdMarker(7," +
                        onlineDevice.name +
                        ")'>关机</span></p>" +
                        "</div>"
                    ); // 创建信息窗口对象
                  } else {
                    var infoWindow = new BMapGL.InfoWindow(
                      "<div style='margin-left:60px;color:#fff;width: 85%;'>" +
                        "<div style='display: inline-block; width: 100%;' ><h3 style='color: #e6b726'>" +
                        onlineDevice.username +
                        "</h3><span style='position: absolute;right: 0;top: 10px;'><img src='../static/images/map/title-zfy.png' alt='实时视频' width='24px' height='24px'></span></div><hr>" +
                        "<div style='width: 90px;display:inline-block'>姓名：</div>" +
                        onlineDevice.username +
                        "</br><div style='width: 90px;display:inline-block'> 设备编号：</div>" +
                        onlineDevice.name +
                        "</br> <div style='width: 90px;display:inline-block'> 电量：</div>" +
                        onlineDevice.status.battery +
                        "%" +
                        "</span></br></p>" +
                        "<p style='font-size:12px;margin-bottom:40px;color:#48dacf;'  class='BmapCtl'><span  style='margin-right: 10px' onclick='remoteCmdMarker(6," +
                        onlineDevice.name +
                        ")'>重启</span><span  style='margin-right: 8px' onclick='remoteCmdMarker(7," +
                        onlineDevice.name +
                        ")'>关机</span></p>" +
                        "</div>"
                    ); // 创建信息窗口对象
                  }
                  this.map.openInfoWindow(infoWindow, marker.getPosition()); // 这里我们也需要将 marker 的位置传递给 openInfoWindow 方法，而不是零售点位置
                };
              })(marker1, i, this.onlineDevice[i])
            );

            var opts = {
              position: new BMapGL.Point(lng, lat), // 指定文本标注所在的地理位置
              offset: new BMapGL.Size(18, -40) // 设置文本偏移量
            };
            // 创建文本标注对象
            var label = new BMapGL.Label(name, opts);
            // 自定义文本标注样式
            label.setStyle({
              color: "#076961",
              borderRadius: "5px",
              borderColor: "#ccc",
              fontWeight: 700,
              fontSize: "15px",
              height: "14px",
              padding: "2px",
              lineHeight: "14px",
              fontFamily: "微软雅黑"
            });

            this.map.addOverlay(label); //添加文本备注
          }
        }
      }
    },

    // 将wgs84转换成Bd09坐标系
    wgs84ToBd09(lng, lat) {
      var PI = (3.14159265358979324 * 3000.0) / 180.0;
      var x = parseFloat(lng),
        y = parseFloat(lat);
      var z = Math.sqrt(x * x + y * y) + 0.00002 * Math.sin(y * PI);
      var theta = Math.atan2(y, x) + 0.000003 * Math.cos(x * PI);
      // var bdLng = z * Math.cos(theta) + 0.0065;
      // var bdLat = z * Math.sin(theta) + 0.006;
      var bdLng = z * Math.cos(theta) + 0.0116;
      var bdLat = z * Math.sin(theta) + 0.0032;
      return [bdLng, bdLat];
    },
    // 报警弹框
    open1() {
      for (let i = 0; i < this.AlarmsList.length; i++) {
        const alarmOriginId = this.AlarmsList[i].alarmOriginId; //报警设备号
        const alarmOriginName = this.AlarmsList[i].alarmOriginName; //报警人员
        const alarmCreateTime = this.AlarmsList[i].alarmCreateTime; //报警时间
        const alarmType = this.AlarmsList[i].alarmType; //报警类型   1车牌  2人脸 3电子围栏 4 sos
        const alarmLng =
          Math.floor(this.AlarmsList[i].alarmLng * 1000000) / 1000000; //经度
        const alarmLat =
          Math.floor(this.AlarmsList[i].alarmLat * 1000000) / 1000000; //纬度
        const alarmContent = this.AlarmsList[i].alarmContent; //报警内容
        const alarmImg = this.AlarmsList[i].alarmImg; //报警图片
        this.sosDeviceNumber = alarmOriginId;
        let alarmContentResult = "";
        let imgShow = "";

        if (alarmImg === null) {
          imgShow = "none";
        } else {
          imgShow = "flex";
        }
        if (alarmType === 1) {
          const match = alarmContent.match(/"numberplateTxt":"([^"]+)"/);
          if (match) {
            alarmContentResult = "目标车牌:" + match[1];
          }
        } else if (alarmType === 2) {
          const match = alarmContent.match(/"faceName":"([^"]+)"/);
          if (match) {
            alarmContentResult = "目标人员:" + match[1];
          }
        } else if (alarmType === 4) {
          // 创建报警音频
          let music1 = new Audio(); //建立一个music1对象
          music1.src = require("../../../assets/img/liveVideo/sos.mp3"); //通过require引入音频
          if (this.$refs.audio) {
            this.$refs.audio.src = music1.src; //此处的audio为代码ref="audio"中的audio
            this.$refs.audio.play(); //play()为播放函数
          }

          this.sendSosDialog = true;
          const httpType = location.protocol === "https:" ? "wss://" : "ws://";
          this.playerSosUrl =
            httpType +
            window.g.LIVE_URL +
            "/" +
            // window.sessionStorage.getItem("token").replaceAll('"', "") +
            window.sessionStorage.getItem("token").replace(/"/g, " ") +
            "/" +
            alarmOriginId +
            "/520.flv";
          // 开发地址
          // this.playerSosUrl =
          //   this.$bpi +
          //   "/" +
          //   window.sessionStorage.getItem("token").replaceAll('"', "") +
          //   "/" +
          //   alarmOriginId +
          //   "/520.flv";
          // console.log(this.playerUrl);
        }

        this.$notify({
          title:
            alarmType == 1
              ? "发现目标车牌"
              : alarmType == 2
              ? "发现目标人员"
              : alarmType == 3
              ? "超出电子围栏"
              : alarmType == 4
              ? "sos求救"
              : "位置监听异常",
          dangerouslyUseHTMLString: true,
          message: `<div style="display:flex; justify-content:space-between;"  >
              <div  style="display:${imgShow}" >
                <img src="data:image/png;base64,${alarmImg}"   alt="Image" width="100" height="110">
              </div>
              <div> 
                <div style='color:green;font-size:18px;'>${alarmCreateTime}</div>
                <div style='color:blue;font-size:18px;margin:9px 0;'>人员:${alarmOriginName}</div>  
                <div style='color:orange;font-size:18px;margin:9px 0;'>设备:${alarmOriginId}</div>  
                <div style='color:red;font-size:20px;'>${alarmContentResult}</div>      
              </div>        
             </div>
             <div style='color:teal;font-size:20px;'>位置:${alarmLng},${alarmLat}</div>
             
             `,
          type: "warning",
          duration: 60000, //多久自动关闭
          offset: 150 //偏移的距离
        });
      }
    },
    // 开始SOS对讲
    startSosCall() {
      // 在创建组件时建立WebSocket连接
      this.createWebSocket();
      // 将前面开启对讲为停止对讲的按钮改为未开启状态
      this.macSosShow = true;
      setTimeout(() => {
        //设备编号
        this.call.id = this.sosDeviceNumber;
        this.play = true;
        // this.audioCtx = new AudioContext({ sampleRate: 8000 });
        // 获取浏览器
        const agent = navigator.userAgent;
        //  如果是火狐就默认系统采样率，其他的默认8000采样率
        if (agent.indexOf("Firefox") > 0) {
          this.audioCtx = new (AudioContext || webkitAudioContext)({});
        } else {
          this.audioCtx = new (AudioContext || webkitAudioContext)({
            sampleRate: 8000
          });
        }
        this.initWs1();
        // 该变量存储当前MediaStreamAudioSourceNode的引用
        // 可以通过它关闭麦克风停止音频传输

        // 创建一个ScriptProcessorNode 用于接收当前麦克风的音频
        this.scriptNode = this.audioCtx.createScriptProcessor(1024, 1, 1);
        // 判断浏览器是否支持音频输入
        navigator.getUserMedia =
          navigator.getUserMedia || navigator.webkitGetUserMedia;
        if (!navigator.getUserMedia) {
          this.$message.warning("浏览器不支持音频输入,请进行相关设置");
        }
        // 告诉后端采样率多少
        this.ws.send(JSON.stringify({ sampleRate: this.audioCtx.sampleRate }));
        navigator.mediaDevices
          .getUserMedia({ audio: true, video: false })
          .then(stream => {
            this.mediaStack = stream;
            this.source = this.audioCtx.createMediaStreamSource(stream);

            this.source.connect(this.scriptNode);
            this.scriptNode.connect(this.audioCtx.destination);
          })
          .catch(function(err) {
            /* 处理error */
            console.log("err", err);
          });
        // 当麦克风有声音输入时，会调用此事件
        // 实际上麦克风始终处于打开状态时，即使不说话，此事件也在一直调用
        this.scriptNode.onaudioprocess = audioProcessingEvent => {
          const inputBuffer = audioProcessingEvent.inputBuffer;
          // 由于只创建了一个音轨，这里只取第一个频道的数据
          const inputData = inputBuffer.getChannelData(0);
          // 通过socket传输数据，实际上传输的是Float32Array
          // let inputData1 = new Float64Array(1024);
          // for (let index = 0; index < 1024; index++) {
          //   inputData1[index] = inputData[index];
          // }
          if (this.ws.readyState === 1) {
            this.ws.send(new Float32Array(inputData));
            // console.log(new Float32Array(inputData));
            // this.compressPCM(inputData);

            // // 创建新的 AudioBuffer 对象
            // const buffer = this.audioCtx.createBuffer(
            //   1,
            //   inputData.length,
            //   this.audioCtx.sampleRate
            // );
            // // 将 inputData 数据存储在 buffer 中的第一个音轨中
            // buffer.getChannelData(0).set(inputData);

            // // 创建新的 AudioBufferSourceNode
            // const sourceNode = this.audioCtx.createBufferSource();
            // sourceNode.buffer = buffer;

            // // 连接 AudioBufferSourceNode 到 AudioContext 目标节点
            // sourceNode.connect(this.audioCtx.destination);
            // // 播放音频
            // if (this.play) {
            //   sourceNode.start();
            // }
          }
        };
      }, 500);
    },

    // 关闭麦克风
    stopSosCall() {
      this.play = false;
      // 切换对讲按钮状态
      this.macSosShow = false;

      // this.play = false;
      // this.mediaStack.getTracks()[0].stop();
      if (this.mediaStack) {
        this.mediaStack.getTracks().forEach(track => {
          track.stop();
        });
        this.scriptNode.disconnect();
      }

      // 关闭websockrt
      this.closeWebSocket();
    },

    // 获取报警信息
    async getNewAlarms() {
      this.AlarmsList = [];

      const { data: res } = await this.$axios.get(
        `${this.$api}/alarm/getNewAlarms`
      );
      // if (res.status != 0) {
      //   return;
      // }
      this.AlarmsList = res.data;
      if (this.AlarmsList.length > 0) {
        this.open1();
      }
      this.setTimeGetAlarmsList = setTimeout(() => {
        this.getNewAlarms();
      }, 5000);
    },
    // 关闭sos视频对话框
    clearPlayerSosDialogVisible() {
      // 关闭视频
      this.playerSosUrl = "";
      // 关闭对话框
      this.sendSosDialog = false;
      // 关闭对讲
      this.stopSosCall();
    },
    // 建立WebSocket连接
    createWebSocket() {
      const httpType = location.protocol === "https:" ? "wss://" : "ws://";
      // this.ws = new WebSocket(
      //   httpType + `${location.host}/websocket/audio/web1`
      // )
      // 开发环境
      // this.ws = new WebSocket(this.$cpi);

      this.ws = new WebSocket(httpType + window.g.Talk_URL);

      // this.ws = new WebSocket("ws://192.168.0.97:8051/speak/token");
      this.ws.onopen = () => {
        console.log("socket 已连接");
      };
    },
    // 关闭WebSocket连接
    closeWebSocket() {
      if (this.ws) {
        this.ws.close();
        // this.ws = null;
      }
    },

    initWs1() {
      this.ws.send(JSON.stringify(this.call)); //发送对讲类型
      this.ws.binaryType = "arraybuffer";
      this.ws.onmessage = ({ data }) => {
        // 将接收的数据转换成与传输过来的数据相同的Float32Array
        const buffer = new Float64Array(data);

        // =======将Int16Array的数据转换成Float32Array======
        // let output = new Float32Array(2048);
        // for (var i = 0; i < 2048; i++) {
        //   let int = buffer[i];
        //   let float = int >= 0x8000 ? -(0x10000 - int) / 0x8000 : int / 0x7fff;
        //   output[i] = float;
        // }
        // this.buffer = output;
        // =======将Int16Array的数据转换成Float32Array======

        // console.log("收到源数据:", data);
        // console.log("收到:", buffer);

        // 创建一个空白的AudioBuffer对象，这里的4096跟发送方保持一致，48000是采样率
        const myArrayBuffer = this.audioCtx.createBuffer(1, 512, 8000);
        // 也是由于只创建了一个音轨，可以直接取到0
        const nowBuffering = myArrayBuffer.getChannelData(0);
        // 通过循环，将接收过来的数据赋值给简单音频对象
        for (let i = 0; i < 512; i++) {
          nowBuffering[i] = buffer[i];
        }
        // 使用AudioBufferSourceNode播放音频
        const source = this.audioCtx.createBufferSource();
        source.buffer = myArrayBuffer;

        const gainNode = this.audioCtx.createGain();
        source.connect(gainNode);
        gainNode.connect(this.audioCtx.destination);
        var muteValue = 1;
        if (!this.play) {
          // 是否静音
          muteValue = 0;
        }
        gainNode.gain.setValueAtTime(muteValue, this.audioCtx.currentTime);
        source.start();
      };
      this.ws.onerror = e => {
        console.log("error", e);
      };
      this.ws.onclose = e => {
        console.log(
          "websocket 断开: " + e.code + " " + e.reason + " " + e.wasClean
        );
        console.log("socket closed");
      };
    },
    // 开始对讲
    startCall(playUrl, index) {
      // 在创建组件时建立WebSocket连接
      this.createWebSocket();

      // 将前面开启对讲为停止对讲的按钮改为未开启状态
      for (let j = 0; j < this.easyPlayer.length; j++) {
        this.easyPlayer[j].IntercomState = true;
      }
      setTimeout(() => {
        // console.log("设备1", playUrl.split("/")[4]);
        var deviceNumber = playUrl.split("/")[4];
        //设备编号
        this.call.id = deviceNumber;
        // console.log(this.call[index].id );
        this.play = true;
        // 当选中后才能切换按钮状态
        if (this.active == index) {
          this.easyPlayer[index].IntercomState = false;
        }
        // this.audioCtx = new AudioContext({ sampleRate: 8000 });
        // 获取浏览器
        const agent = navigator.userAgent;
        //  如果是火狐就默认系统采样率，其他的默认8000采样率
        if (agent.indexOf("Firefox") > 0) {
          this.audioCtx = new (AudioContext || webkitAudioContext)({});
        } else {
          this.audioCtx = new (AudioContext || webkitAudioContext)({
            sampleRate: 8000
          });
        }
        this.initWs1();
        // 该变量存储当前MediaStreamAudioSourceNode的引用
        // 可以通过它关闭麦克风停止音频传输

        // 创建一个ScriptProcessorNode 用于接收当前麦克风的音频
        this.scriptNode = this.audioCtx.createScriptProcessor(1024, 1, 1);
        // 判断浏览器是否支持音频输入
        navigator.getUserMedia =
          navigator.getUserMedia || navigator.webkitGetUserMedia;
        if (!navigator.getUserMedia) {
          this.$message.warning("浏览器不支持音频输入,请进行相关设置");
        }
        // 告诉后端采样率多少
        this.ws.send(JSON.stringify({ sampleRate: this.audioCtx.sampleRate }));
        navigator.mediaDevices
          .getUserMedia({ audio: true, video: false })
          .then(stream => {
            this.mediaStack = stream;
            this.source = this.audioCtx.createMediaStreamSource(stream);

            this.source.connect(this.scriptNode);
            this.scriptNode.connect(this.audioCtx.destination);
          })
          .catch(function(err) {
            /* 处理error */
            console.log("err", err);
          });

        // 当麦克风有声音输入时，会调用此事件
        // 实际上麦克风始终处于打开状态时，即使不说话，此事件也在一直调用
        this.scriptNode.onaudioprocess = audioProcessingEvent => {
          const inputBuffer = audioProcessingEvent.inputBuffer;
          // 由于只创建了一个音轨，这里只取第一个频道的数据
          const inputData = inputBuffer.getChannelData(0);
          // 通过socket传输数据，实际上传输的是Float32Array
          // let inputData1 = new Float64Array(1024);
          // for (let index = 0; index < 1024; index++) {
          //   inputData1[index] = inputData[index];
          // }
          if (this.ws.readyState === 1) {
            this.ws.send(new Float32Array(inputData));
            // console.log(new Float32Array(inputData));
            // this.compressPCM(inputData);

            // // 创建新的 AudioBuffer 对象
            // const buffer = this.audioCtx.createBuffer(
            //   1,
            //   inputData.length,
            //   this.audioCtx.sampleRate
            // );
            // // 将 inputData 数据存储在 buffer 中的第一个音轨中
            // buffer.getChannelData(0).set(inputData);

            // // 创建新的 AudioBufferSourceNode
            // const sourceNode = this.audioCtx.createBufferSource();
            // sourceNode.buffer = buffer;

            // // 连接 AudioBufferSourceNode 到 AudioContext 目标节点
            // sourceNode.connect(this.audioCtx.destination);
            // // 播放音频
            // if (this.play) {
            //   sourceNode.start();
            // }
          }
        };
      }, 500);
    },
    // 关闭麦克风
    stopCall(index) {
      this.play = false;
      // 当选中后才能切换按钮状态
      if (this.active == index) {
        this.easyPlayer[index].IntercomState = true;
      }
      // this.play = false;
      // this.mediaStack.getTracks()[0].stop();
      if (this.mediaStack) {
        this.mediaStack.getTracks().forEach(track => {
          track.stop();
        });
        this.scriptNode.disconnect();
      }
      // 关闭websockrt
      this.closeWebSocket();
    },

    // 展开折叠
    clickOpenHidden() {
      this.isOpen = !this.isOpen;

      let openBox = this.$refs.openBox;
      let boxwidth = openBox.offsetWidth;
      // console.log(boxwidth);
      // console.log(openBox);

      if (boxwidth === this.openWidth) {
        //展开
        openBox.style.width = "auto";
        boxwidth = openBox.offsetWidth;
        openBox.style.width = this.openWidth + "px";
        let f = document.body.offsetWidth; // 必加 (不知道具体是为什么必加, 测试时发现若不加在展开时候会没有过渡效果)
        openBox.style.width = boxwidth + "px";
      } else {
        //折叠
        openBox.style.width = this.openWidth + "px";
      }
    },
    // 切换地图模式
    changModelMap() {
      this.changModel = true;
    },
    // 切换视频模式
    changModelVideo() {
      this.changModel = false;
    },
    // 在线设备信息
    levelOrderTraverse() {
      const levelNodes = [...this.ArchInfo];
      while (levelNodes.length) {
        const temp = [],
          count = levelNodes.length;
        for (let i = 0; i < count; i++) {
          const node = levelNodes.shift();
          if (node.type === 2) {
            // 如果 type 为 2，将 name 添加到type=2的 username 中
            if (node.name) {
              for (let j = 0; j < node.children.length; j++) {
                node.children[j].username = node.name;
              }
            }
          }
          if (node.type === 3 && node.status.online === true) {
            // 如果 type 为 3，并且 status 的 online 为 true，添加到 temp 中
            temp.push(node);
          }

          if (node.children) levelNodes.push(...node.children);
        }
        this.onlineDevice.push(...temp);
      }
      return this.onlineDevice;
    },

    pfOne() {
      this.easyPlayer = [];
      this.playerWidth = "99%";
      this.playerHeight = "99%";
      for (var i = 1; i <= 1; i++) {
        var obj = {};
        obj.url = "";
        obj.muted = true;
        obj.autoplay = true;
        // 控制对讲状态
        obj.IntercomState = true;
        // 是否显示云台
        obj.ytBoxShow = false;
        obj.num = i;
        this.easyPlayer.push(obj);
      }
    },
    pfFour() {
      this.easyPlayer = [];
      this.playerWidth = "49.5%";
      this.playerHeight = "49.5%";
      for (var i = 1; i <= 4; i++) {
        var obj = {};
        obj.url = "";
        obj.muted = true;
        obj.autoplay = true;
        // 控制对讲状态
        obj.IntercomState = true;
        // 是否显示云台
        obj.ytBoxShow = false;
        obj.num = i;
        this.easyPlayer.push(obj);
      }
    },
    pfEight() {
      this.easyPlayer = [];
      this.playerWidth = "24.5%";
      this.playerHeight = "49.5%";
      for (var i = 1; i <= 8; i++) {
        var obj = {};
        obj.url = "";
        obj.muted = true;
        obj.autoplay = true;
        // 控制对讲状态
        obj.IntercomState = true;
        // 是否显示云台
        obj.ytBoxShow = false;
        obj.num = i;
        this.easyPlayer.push(obj);
      }
    },
    pfSixteen() {
      this.easyPlayer = [];
      this.playerWidth = "24.5%";
      this.playerHeight = "24.5%";
      for (var i = 1; i <= 16; i++) {
        var obj = {};
        obj.url = "";
        obj.muted = true;
        obj.autoplay = true;
        // 控制对讲状态
        obj.IntercomState = true;
        // 是否显示云台
        obj.ytBoxShow = false;
        obj.num = i;
        this.easyPlayer.push(obj);
      }
    },
    pfThirty() {
      this.easyPlayer = [];
      this.playerWidth = "16.2%";
      this.playerHeight = "19.5%";
      for (var i = 1; i <= 30; i++) {
        var obj = {};
        obj.url = "";
        obj.muted = true;
        obj.autoplay = true;
        // 控制对讲状态
        obj.IntercomState = true;
        // 是否显示云台
        obj.ytBoxShow = false;
        obj.num = i;
        this.easyPlayer.push(obj);
      }
    },
    handleNodeClick(Treedevies) {
      // 设备编号：
      this.controlInfo.deviceNumber = Treedevies.name;
      this.deviceNumber = Treedevies.name;
      // 当设备在线且有经纬度时，点击树设备执行
      if (
        Treedevies.type == 3 &&
        Treedevies.status.online == true &&
        Treedevies.status.lng !== null &&
        Treedevies.status.lat !== null &&
        Treedevies.status.lng !== 0 &&
        Treedevies.status.lat !== 0
      ) {
        // 将wgs84坐标转Bd09坐标
        var point = this.wgs84ToBd09(
          Treedevies.status.lng,
          Treedevies.status.lat
        );

        // 改变地图中心点经度
        this.mapCenterLng = point[0];
        // 改变地图中心点纬度
        this.mapCenterLat = point[1];
        // 地图缩放级别
        this.mapZoom = 19;
        // 更新地图
        this.initMap();
      }

      // console.log("Treedevies", Treedevies);
    },
    // 全部关闭视频
    onStop() {
      for (let index = 0; index < this.easyPlayer.length; index++) {
        this.easyPlayer[index].url = "";
        // 关闭对讲
        if (this.mediaStack) {
          this.stopCall();
        }
        this.easyPlayer[index].IntercomState = true;
      }
    },
    onCloes(index) {
      this.easyPlayer[index].url = "";
      // 如果是选中的窗口且状态为开启对讲就关闭对讲，如果不是就不关闭
      if (
        this.active == index &&
        this.easyPlayer[index].IntercomState == false
      ) {
        if (this.mediaStack) {
          this.stopCall();
        }

        this.easyPlayer[index].IntercomState = true;
      }
    },
    onActive(val) {
      this.active = val;
    },
    onPlay() {
      // 播放
      this.easyPlayer[this.active].url = this.playerUrl;
      //云台显示
      this.easyPlayer[this.active].ytBoxShow = this.ytBox;

      // console.log("easyPlayer", this.$refs.easyPlayer);
      // const audioElement = document.getElementById("audio");
    },
    restartPlayer(e) {
      console.log("错误捕获", e.currentTarget.dataset);
      // 错误捕获
      const { index } = e.currentTarget.dataset;
      const playerStr = "player" + index;
      let [player] = this.$refs[playerStr];
      player = player.getVueInstance();
      this.destroyPlayer();
      player.initPlayer(); // 重新初始化播放器
    },

    //  获取组织架构信息
    async getDepPersonDevTree() {
      let id = sessionStorage.getItem("depId1");
      if (id) {
        const { data: res } = await this.$axios.get(
          `${this.$api}/getDepPersonDevTree?depId=${id}`
        );
        if (res.status != 0) {
          return this.$message.error(res.msg);
        }
        this.ArchInfo = res.data;
      } else {
        const { data: res } = await this.$axios.get(
          `${this.$api}/getDepPersonDevTree`
        );
        if (res.status != 0) {
          return this.$message.error(res.msg);
        }
        this.ArchInfo = res.data;
      }
    },
    // 全部设备
    allList() {
      this.ArchInfoShow = true;
    },
    // 在线设备列表
    onlineList() {
      this.ArchInfoShow = false;
      if (this.ArchInfoShow == true) {
        clearInterval(this.setInt);
      }
      let data = this.ArchInfo[0];
      this.onlineArchInfo = [data];
      var lastLength = data.children.length;
      for (var i = 0; i < data.children.length; i++) {
        if (data.children[i].type != 3) {
          this.onlyOnline(data.children[i], i, data);
          if (lastLength != data.children.length) {
            lastLength = data.children.length;
            i--;
          }
        }
      }
      this.setInt = setInterval(() => {
        if (this.ArchInfoShow == true) {
          clearInterval(this.setInt);
        }
        let data = this.ArchInfo[0];
        this.onlineArchInfo = [data];
        var lastLength = data.children.length;
        for (var i = 0; i < data.children.length; i++) {
          if (data.children[i].type != 3) {
            this.onlyOnline(data.children[i], i, data);
            if (lastLength != data.children.length) {
              lastLength = data.children.length;
              i--;
            }
          }
        }
      }, 3000);
    },
    // 遍历在线设备树
    onlyOnline(node, index, parent) {
      if (node.type != 3 || (node.type == 3 && !node.status.online)) {
        if (node.children == null || node.children.length == 0) {
          parent.children.splice(index, 1);
        } else {
          var lastLength = node.children.length;
          for (var i = 0; i < node.children.length; i++) {
            this.onlyOnline(node.children[i], i, node);
            if (lastLength != node.children.length) {
              lastLength = node.children.length;
              i--;
            }
          }
          if (node.children.length == 0) {
            parent.children.splice(index, 1);
          }
        }
      }
    },

    //远程控制
    async remoteCmd(cmdType) {
      if (cmdType == 8) {
        const confirmVal = await this.$confirm(
          "此操作将永久清除媒体数据, 是否继续?",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }
        ).catch(err => err);
        if (confirmVal != "confirm") {
          return this.$message.info("已取消删除");
        }
      }
      this.controlInfo.cmdType = cmdType;
      const { data: res } = await this.$axios.get(`${this.$api}/remotecmd`, {
        params: this.controlInfo
      });
      if (res.status != 0) {
        return this.$message.error(res.msg);
      }
      this.$message.success(res.msg);
      // 关闭远程发送广播消息
      this.innerPushTxtVisible = false;
    },
    // 关闭智能广播发送消息对话框时执行
    clearinnerPushTxtVisiblee() {
      this.controlInfo.txt = "";
    },
    //通过定位坐标打开远程控制
    async remoteCmdMarker(cmdType, deviceNumber) {
      if (cmdType == 8) {
        const confirmVal = await this.$confirm(
          "此操作将永久清除媒体数据, 是否继续?",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }
        ).catch(err => err);
        if (confirmVal != "confirm") {
          return this.$message.info("已取消删除");
        }
      }
      this.controlInfo.deviceNumber = deviceNumber;
      this.controlInfo.cmdType = cmdType;
      const { data: res } = await this.$axios.get(`${this.$api}/remotecmd`, {
        params: this.controlInfo
      });
      if (res.status != 0) {
        return this.$message.error(res.msg);
      }
      this.$message.success(res.msg);
    },
    //云台控制
    async cameraCmd(cmd) {
      this.controlInfo.cmd = cmd;
      const { data: res } = await this.$axios.get(
        `${this.$api}/ghbDeviceControl/cameraCmd`,
        {
          params: this.controlInfo
        }
      );
      if (res.status != 0) {
        return this.$message.error(res.msg);
      }
      // this.$message.success(res.msg);
    },
    // 查看单设备实时视频
    playVideo(value) {
      // console.log(value);
      setTimeout(() => {
        // 如果是国标球机就显示云台
        this.ytBox = false;
        if (value.devideType == 2 && value.devProtocol == 2) {
          this.ytBox = true;
        }
        const httpType = location.protocol === "https:" ? "wss://" : "ws://";
        // console.log(httpType + location.hostname + ":" + window.g.LIVE_port);
        // 开发地址
        // this.playerUrl =
        //   this.$bpi +
        //   "/" +
        //   window.sessionStorage.getItem("token").replaceAll('"', "") +
        //   "/" +
        //   this.deviceNumber +
        //   "/520.flv";
        this.playerUrl =
          httpType +
          window.g.LIVE_URL +
          "/" +
          // window.sessionStorage.getItem("token").replaceAll('"', "") +
          window.sessionStorage.getItem("token").replace(/"/g, " ") +
          "/" +
          this.deviceNumber +
          "/" +
          Math.floor(Math.random() * 100) +
          1 +
          ".flv";
        console.log("playerUrl:",this.playerUrl);
        this.changModel = false;
        this.onPlay();
      }, 200);
    },
    // 地图坐标打开查看单设备实时视频
    playVideoMarker(value) {
      setTimeout(() => {
        // 如果是国标球机就显示云台
        this.ytBox = false;
        if (value.devideType == 2 && value.devProtocol == 2) {
          this.ytBox = true;
        }
        const httpType = location.protocol === "https:" ? "wss://" : "ws://";
        // console.log(httpType + location.hostname + ":" + window.g.LIVE_port);
        // 开发地址
        // this.playerUrl =
        //   this.$bpi +
        //   "/" +
        //   window.sessionStorage.getItem("token").replaceAll('"', "") +
        //   "/" +
        //   this.deviceNumber +
        //   "/520.flv";
        this.playerUrl =
          httpType +
          window.g.LIVE_URL +
          "/" +
          // window.sessionStorage.getItem("token").replaceAll('"', "") +
          window.sessionStorage.getItem("token").replace(/"/g, " ") +
          "/" +
          value.name +
          "/520.flv";
        // console.log(this.playerUrl);
        this.changModel = false;
        this.onPlay();
      }, 200);
    },

    handleCheckChange(checkedNodes) {
      // console.log(checkedNodes);
    },

    renderContent(h, { node, data, store }) {
      // console.log("data", data);
      // console.log("node", node);
      // console.log("node", store);
      //每个父节点统计子节点数量方法
    }
  }
};
</script>

<style lang="less" scoped>
.wrapper {
  height: calc(100vh - 101px);
  box-sizing: border-box;
  display: flex;
  align-items: center;
  cursor: pointer;
  .openbox-container {
    width: 0;
    width: 350px;
    height: calc(100vh - 101px);
    overflow: hidden;
    transition: width ease 0.5s; //动画效果
    background: transparent;
    box-sizing: border-box;
    display: flex;
    .content {
      // background: rgb(28, 219, 219);
      /* background-color: #001114; */
      background-image: url(../../../assets/img/dataBoard/box2.png);
      /*  背景图片平铺 */
      background-repeat: repeat;
      background-size: 100% 100%;
      opacity: 0.8;
      z-index: 999;

      .btn-class {
        margin-top: 40px;
        height: 55px;
        display: flex;
        justify-content: center;
      }

      /* 切换模式按钮 */
      .model-btn {
        margin: 5px;
        padding: 10px 20px;
        /* background: #00c9b3; */
        background-image: url(../../../assets/img/liveVideo/btn2.png);
        /*  背景图片平铺 */
        background-repeat: repeat;
        background-size: 100% 100%;
        color: #eff3f3;
        font-size: 1.2rem;
        font-weight: bold;
        border-radius: 5px;
      }
    }
  }
}

/* 组织架构信息列表区域 */
.treeBox {
  width: 340px;
  height: calc(100vh - 270px) !important;
  overflow-y: auto !important;
  overflow-x: auto !important;
  margin-left: 10px;
  display: flex;
  // justify-content: center;

  // ul {
  //   color: #0ab5df;
  //   list-style: none;
  //   padding-left: 15px;
  // }
}

/* 中间地图或视频窗口 */
.center-box {
  width: 100%;
  height: calc(100vh - 101px);
  /* position: relative; */
  /* border: 1px solid red; */
}

/* 视频窗口显示区域 */
.box {
  width: 100%;
  height: 81vh;
  display: flex;
  flex-wrap: wrap;
  position: relative;
  justify-content: center;
}

/* 视频模块 */
.video1Model {
  width: 100%;
  /* height: 85vh; */
  height: calc(100vh - 101px);
  /* float: right; */
  /* margin: auto; */
}

/* 百度地图 */
.bmap-container {
  width: 100%;
  height: calc(100vh - 101px);
  color: #076961;
}

/* 播放窗口边框 */
.boder {
  border: 1px solid #119cf9;
}

/* 选择后的边框颜色 */
.boder-active {
  border: 1px solid #f36804;
}

/* 播放窗口数字 */
.num {
  /* position: absolute; */
  z-index: 10;
  color: red;
  font-size: 30px;
  margin-left: 2px;
  display: inline-block;
}

/* 视频关闭按钮 */
.closes {
  // display: inline-block;
  position: absolute;
  margin-top: 2px;
  margin-left: 2px;
  cursor: pointer;
  // margin-top: 2px;
  width: 40px;
  height: 20px;
  text-align: center;
  line-height: 20px;
  font-size: 12px;
  color: #fff;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 999;
}

#playerContainer {
  width: 100%;
  height: 100%;
  position: relative;
}
#playerContainer1 {
  position: relative;
}

#intercomButton {
  display: none;
  position: absolute;
  top: 90%;
  left: 98%;
  transform: translate(-90%, -98%);
}
#intercomButton1 {
  position: absolute;
  top: 90%;
  left: 98%;
  transform: translate(-90%, -98%);
}
// 云台背景
#ytButton {
  display: none;
  position: absolute;
  top: 90%;
  right: 95%;
  transform: translate(95%, -98%);
  background-image: url(../../../assets/img/liveVideo/ytBox.png);
  background-size: 100px;
  width: 100px;
  height: 100px;
}
// 向上按钮
.up {
  overflow: hidden;
  position: absolute;
  top: -8px;
  right: 26px;
  // transform-origin: 50% 100%;
}
// 向左按钮
.rg {
  overflow: hidden;
  position: absolute;
  top: 27px;
  right: -8px;
  transform: rotate(90deg);
}
// 向下按钮
.dw {
  overflow: hidden;
  position: absolute;
  bottom: -8px;
  right: 26px;
  transform: rotate(180deg);
}
// 向左按钮
.lt {
  overflow: hidden;
  position: absolute;
  top: 27px;
  left: -8px;
  transform: rotate(-90deg);
}

// 云台放大按钮

.zoomIn {
  position: absolute;
  top: 29px;
  left: 30px;
}

.zoomIn:hover {
  width: 41px;
  cursor: pointer;
}

.zoomOut:hover {
  width: 41px;
  cursor: pointer;
}
.zoomOut {
  position: absolute;
  top: 52px;
  left: 30px;
}

.cameraCmd {
  font-size: 3rem;
  color: rgba(240, 248, 255, 0.943);
}
.cameraCmd:hover {
  color: rgba(86, 173, 250, 0.943);
  cursor: pointer;
}

.box:hover #intercomButton {
  display: block;
}
.box:hover #ytButton {
  display: block;
}

.foldopen {
  height: calc(100vh - 101px);
  width: 100%;
  display: flex;
  background-image: url(../../../assets/img/dataBoard/bg.png);
  flex-direction: row;
}

// +++++++++++++++tree++++++++++++++++++
.bigTree {
  height: 26px;
  display: flex;
}
.leftTree {
  width: 95%;
  display: flex;
  vertical-align: center;
  align-items: center;
}

.rightTree {
  position: relative;
  right: 0px;
  margin-left: 5px;
  // width: 1%;
  vertical-align: center;
}
//远程控制和实时视频按钮 :hover
.imgHover:hover {
  background: #18d0f13f;
}
// 远程控制对话框放的方按钮的盒子
.controlBox {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

.controlItem {
  width: 110px;
  height: 100px;
  background-color: #073365;
  margin: 5px;
  border: 1px solid #0c30fa84;
  color: #03bdfb;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.controlItem:hover {
  background-color: #3eb4c475;
  border: 1px solid #687df784;
}

// 切换设备全部列表和在线设备列表按钮区域
.listStatusBtn {
  display: flex;
  justify-content: center;
}

/* 切换视频分屏按钮 */
.fp-btn {
  padding: 5px 10px;
  // margin-left: 10px;
  background: #00c9b3;
  color: #005444;
  margin: 10px 5px;
}

//格式化百度弹出对话框
/deep/ .BMap_bubble_pop {
  width: 350px !important;
  background-image: url(../../../assets/img/liveVideo/BmapBox.png);
  /*  背景图片平铺 */
  background-repeat: repeat;
  background-size: 100% 100%;
  background-color: transparent !important;
  border: none !important;
}

// Mack弹出对话框控制按钮
/deep/.BmapCtl span:hover {
  cursor: pointer;
  color: #00c9b3;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/Main/LiveVideo/liveVideo.vue